import { DocumentRequestDashboardComponent } from "./document-request-dashboard.component";
export var documentrequestDashboard = [
    {
        path: 'document-request-dashboard',
        component: DocumentRequestDashboardComponent
    }
];
var DocumentRequestDashboardRoutingModule = (function () {
    function DocumentRequestDashboardRoutingModule() {
    }
    return DocumentRequestDashboardRoutingModule;
}());
export { DocumentRequestDashboardRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-request-dashboard/document-request-dashboard-routing.module.ts.pre-build-optimizer.js